import { FormEvent, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { appPathFromReturnTo, errorMessage, isMtibEmail, isValidEmail, normalizeEmail } from '../lib/utils';
import { useToast } from '../context/ToastContext';
import { useStaffAuth } from '../auth/StaffAuthContext';
import { storage } from '../lib/storage';
import MeetingCodeForm from '../components/MeetingCodeForm';

export default function LandingPage() {
  const [email, setEmail] = useState('');
  const [staffBusy, setStaffBusy] = useState(false);
  const { identity, requestEmailOtp } = useStaffAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const returnTo = appPathFromReturnTo(params.get('returnTo'));

  useEffect(() => {
    if (identity.loading || identity.profileError || !identity.isAuthenticated) return;
    navigate(identity.hasProfile ? returnTo : `/staff-onboarding?returnTo=${encodeURIComponent(returnTo)}`, { replace: true });
  }, [identity.hasProfile, identity.isAuthenticated, identity.loading, identity.profileError, navigate, returnTo]);

  const submitStaff = async (event: FormEvent) => {
    event.preventDefault();
    const normalized = normalizeEmail(email);
    if (!isValidEmail(normalized) || !isMtibEmail(normalized)) return showToast('Masukkan alamat e-mel @mtib.gov.my yang sah.', 'error');
    setStaffBusy(true);
    try {
      await requestEmailOtp(normalized);
      storage.setPendingStaffAuthEmail(normalized);
      navigate(`/staff-auth?returnTo=${encodeURIComponent(returnTo)}`, { replace: true });
    } catch (error) { showToast(`Kod pengesahan tidak dapat dihantar. ${errorMessage(error)}`, 'error'); }
    finally { setStaffBusy(false); }
  };

  return <main className="auth-page"><section className="auth-card landing-card">
    <img className="auth-logo-image" src="/mtib-logo.png" alt="Malaysian Timber Industry Board (MTIB)" />
    <h1>Kehadiran</h1>
    <section className="landing-section" aria-labelledby="join-meeting-title">
      <div className="eyebrow">Sertai mesyuarat</div><h2 id="join-meeting-title">Masukkan kod mesyuarat yang dipaparkan oleh <em>Host</em>.</h2>
      <MeetingCodeForm autoFocus onResolved={(meetingId) => navigate(`/checkin/${meetingId}`)} />
    </section>
    <section className="landing-section landing-staff-section" aria-labelledby="staff-signin-title">
      <div className="eyebrow">Pegawai MTIB</div><h2 id="staff-signin-title">Log masuk menggunakan e-mel @mtib.gov.my.</h2>
      <form onSubmit={submitStaff} className="form-stack"><label className="field"><span>E-mel</span><input type="email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder="nama@mtib.gov.my" autoComplete="email" required /></label><button className="button button-secondary button-block" disabled={staffBusy}>{staffBusy ? 'Sedang menghantar…' : 'Teruskan'}</button></form>
    </section>
  </section></main>;
}
